/** admin/families — API. */
import { http } from '../../_shared/http';
import type {
  AdminCreateFamilyPayload,
  AdminUpdateFamilyPayload,
  FamiliesListResponse,
  FamilyOverview,
} from './types';

export const adminFamiliesApi = {
  list: (page = 1, limit = 20) =>
    http.get<FamiliesListResponse>(`/family/list-all?page=${page}&limit=${limit}`),

  getById: (id: string) => http.get<FamilyOverview>(`/family/get-by-id/${id}`),

  create: (payload: AdminCreateFamilyPayload) => http.post<FamilyOverview>('/family/create', payload),

  update: (id: string, payload: AdminUpdateFamilyPayload) =>
    http.patch<FamilyOverview>(`/family/update/${id}`, payload),
};
